import Image from "gatsby-image";
import React from "react";
import {BlooadlabImage} from "./BlooadlabImage";
import Opengraph from "../../../../assets/images/cases/bloodlab/og.png"

export const BloodlabData = () => {
  const images = BlooadlabImage();
  return {
    color:       "#0F2651",
    title:       "Bloodlab",
    seo:
                 "System, który dba o Twoje zdrowie.",
    slug:        "bloodlab",
    opengraph:   Opengraph,
    hero:        {
      title:      "System, który dba o Twoje zdrowie.",
      color:      "#00609A",
      background: (
                    <Image
                      alt=""
                      objectPosition={"center"}
                      objectFit={"cover"}
                      fluid={images.hero.childImageSharp.fluid}
                    />
                  ),
      detail:     (
                    <Image
                      alt=""
                      objectPosition={"center"}
                      objectFit={"contain"}
                      fluid={images.detail.childImageSharp.fluid}
                    />
                  ),
    },
    what_we_did: {
      title:        "Usługi medyczne w każdym miejscu i czasie",
      technologies: [
        "Strona WWW",
        "CMS",
        "Integracja z API",
        "Logo",
      ],
      text:
                    "W zdrowym ciele zdrowy duch! A ponieważ wiemy, że dbanie o samego siebie jest drogą do sukcesu, chcemy przekazywać to innym i zachęcać do zdrowego trybu życia. Stworzyliśmy pierwszy w Polsce system, dzięki któremu regularne badania są o wiele prostsze. Jak? Poprzez analizę i objaśnienie wyników online. Współpraca z BloodLab polegała na opracowaniu strony internetowej, która pozwala na automatyczną i spersonalizowaną interpretację wyników najpopularniejszych badań laboratoryjnych. ",
      list:         [
        "Przeprowadziliśmy spotkania warsztatowe ",
        "Opracowaliśmy moodboard z inspiracjami",
        "Wykonaliśmy logo",
        "Opracowaliśmy makiety funkcjonalne i projety graficzne",
        "Stworzyliśmy stronę internetową",
      ],
    },
    list:        {
      background: (
                    <Image
                      alt=""
                      objectPosition={"center"}
                      objectFit={"contain"}
                      fluid={images.list_bg.childImageSharp.fluid}
                    />
                  ),
      detail:     (
                    <Image
                      alt=""
                      objectPosition={"center"}
                      objectFit={"contain"}
                      fluid={images.list_detail.childImageSharp.fluid}
                    />
                  ),
    },

    full_images:    {
      first:    {
        image: (
                 <Image
                   alt=""
                   objectPosition={"center"}
                   objectFit={"contain"}
                   fluid={images.full_1.childImageSharp.fluid}
                 />
               ),
      },
      second:   {
        image: (
                 <Image
                   alt=""
                   objectPosition={"center"}
                   objectFit={"contain"}
                   fluid={images.full_2.childImageSharp.fluid}
                 />
               ),
      },
      third:    {
        image: (
                 <Image
                   alt=""
                   objectPosition={"center"}
                   objectFit={"contain"}
                   fluid={images.full_3.childImageSharp.fluid}
                 />
               ),
      },
      fourth:   {
        image: (
                 <Image
                   alt=""
                   objectPosition={"center"}
                   objectFit={"contain"}
                   fluid={images.full_4.childImageSharp.fluid}
                 />
               ),
      },
      fifth:    {
        image: (
                 <Image
                   alt=""
                   objectPosition={"center"}
                   objectFit={"contain"}
                   fluid={images.full_5.childImageSharp.fluid}
                 />
               ),
      },
      sixth:    {
        image: (
                 <Image
                   alt=""
                   objectPosition={"center"}
                   objectFit={"contain"}
                   fluid={images.full_6.childImageSharp.fluid}
                 />
               ),
      },
      seventh:  {
        image: (
                 <Image
                   alt=""
                   objectPosition={"center"}
                   objectFit={"contain"}
                   fluid={images.full_7.childImageSharp.fluid}
                 />
               ),
      },
      eighth:   {
        image: (
                 <Image
                   alt=""
                   objectPosition={"center"}
                   objectFit={"contain"}
                   fluid={images.full_8.childImageSharp.fluid}
                 />
               ),
      },
      ninth:    {
        image: (
                 <Image
                   alt=""
                   objectPosition={"center"}
                   objectFit={"contain"}
                   fluid={images.full_9.childImageSharp.fluid}
                 />
               ),
      },
      tenth:    {
        image: (
                 <Image
                   alt=""
                   objectPosition={"center"}
                   objectFit={"contain"}
                   fluid={images.full_10.childImageSharp.fluid}
                 />
               ),
      },
      eleventh: {
        image: (
                 <Image
                   alt=""
                   objectPosition={"center"}
                   objectFit={"contain"}
                   fluid={images.full_11.childImageSharp.fluid}
                 />
               ),
      },
      twelfth:  {
        image: (
                 <Image
                   alt=""
                   objectPosition={"center"}
                   objectFit={"contain"}
                   fluid={images.full_12.childImageSharp.fluid}
                 />
               ),
      },
    },
    headers:        {},
    text_boxes:     {
      first:   {
        title: "Klikasz w przycisk i otrzymujesz wynik",
        text:  "Ponieważ BloodLab to nowy projekt, konieczne było wykonanie logo. Wykorzystaliśmy elementy, które nasuwają skojarzenia z oferowaną usługą. Krew i odcienie czerwieni kojarzą się z badaniami labolatoryjnymi. Cały synget nawiązuje do przycisku lub przełącznika, co symbolizuje szybki, prosty i nowoczesny sposób na interpretacje wyników.",
      },
      second:  {
        title: "Ale najpierw... poznajmy się lepiej",
        text:
               "Prace rozpoczęliśmy od spotkań warsztatowych z klientem. Omówiliśmy najważniejsze zagadnienia, poznaliśmy oczekiwania BloodLab i przeprowadziliśmy warsztaty, które pozwoliły nam na obranie celów i ich skuteczną realizację. Dzieki temu wykonany projekt jest w pełni dopasowany do potrzeb BloodLab - zarówno przedstawicieli firmy, jak i użytkowników systemu.",
      },
      third:   {
        title: "Jak korzystać z BloodLab?",
        text:
               "Strona jest intuicyjna, a wszystkie informacje zaprezentowane są w przejrzysty sposób. By otrzymać interpretację wyników swoich badań, należy je po prostu wpisać lub załączyć w systemie. Obsługuje on pliki zarówno w rozszerzeniu .jpg, jak i .pdf. System BloodLab odczytuje wyniki badań z pliku i wyświetla je na ekranie.",
      },
      fourth:  {
        title: "Wyniki Twoich badań w dobrych rękach",
        text:
               "Zaprojektowane przez nas logo - oprócz tego, że wpisuje się w ideę całego szlaku - jest przede wszystkim użyteczne. Bez problemu można je wykorzystać na wielu formatach zarówno w internecie, jak i poza nim, a ono nie straci na jakości i nadal będzie czytelne. ",
      },
      fifth:   {
        title: "Dbaj o swoje zdrowie z BloodLab",
        text:
               "Na stronie internetowej umieściliśmy zakładkę bloga. Oprócz tego, że stanowi bardzo dobre źródło informacji na różne tematy medyczne, wspiera także pozycjonowanie się BloodLab w wyszukiwarce internetowej. A dla tych, którzy szukają informacji o tym, jak korzystać z możliwości systemu, przygotowaliśmy zakładkę FAQ. ",
      },
      sixth:   {
        title: "UX Design na najwyższym poziomie",
        text:
               "Przeglądanie stron internetowych może budzić wiele emocji. By w przypadku strony BloodLab były one zawsze pozytywne, skupiliśmy się przede wszystkim na odczuciach, doświadczeniach i potrzebach użytkowników. Witryna jest zgodna z założeniami user experience, dzięki czemu korzystanie z niej to czysta przyjemność.",
      },
      seventh: {
        title: "Integracja z API klienta",
        text:
               "Strona połączona jest z API BloodLab. Co to oznacza w praktyce? Dzięki temu możliwa jest łączność systemów i baz danych między sobą,  przy wykorzystaniu uniwersalnych protokołów i plików-nośników danych. Strona BloodLab jest nowoczesna i elastyczna.",
      },
      eighth:  {
        title: "Autorski system zarządzania treścią",
        text:
               "Strona internetowa jest oparta na naszym autorskim systemie CMS. Pozwala to na samodzielne modyfikowanie treści strony przez przedstawicieli BloodLab. Dlaczego takie rozwiązanie się sprawdza? Możesz dodawać, zmieniać, usuwać poszczególne podstrony, a nasz CMS jest intuicyjny, wydajny i przede wszystkim bezpieczny. ",
      },
      ninth:   {
        title: <>Wygodne korzystanie z&nbsp;urządzeń mobilnych</>,
        text:
               "By korzystanie z systemu BloodLab było dla użytkowników jeszcze łatwiejsze, dostosowaliśmy go do urządzeń mobilnych. Układ i wygląd strony automatycznie dopasowuje się do urządzenia, z którego aktualnie korzystasz. W końcu jak wynika z najnowszych badań, ponad połowa Polaków przegląda strony internetowa za pomocą telefonu. ",
      },
    },
    content_images: {
      logo:   (
                <Image
                  alt=""
                  objectPosition={"center"}
                  objectFit={"contain"}
                  fluid={images.img_01.childImageSharp.fluid}
                />
              ),
      first:  (
                <Image
                  alt=""
                  objectPosition={"center"}
                  objectFit={"contain"}
                  fluid={images.img_1.childImageSharp.fluid}
                />
              ),
      second: (
                <Image
                  alt=""
                  objectPosition={"center"}
                  objectFit={"contain"}
                  fluid={images.img_2.childImageSharp.fluid}
                />
              ),
      third:  (
                <Image
                  alt=""
                  objectPosition={"center"}
                  objectFit={"contain"}
                  fluid={images.img_3.childImageSharp.fluid}
                />
              ),
      fourth: (
                <Image
                  alt=""
                  objectPosition={"center"}
                  objectFit={"contain"}
                  fluid={images.img_4.childImageSharp.fluid}
                />
              ),
      fifth:  (
                <Image
                  alt=""
                  objectPosition={"center"}
                  objectFit={"contain"}
                  fluid={images.img_5.childImageSharp.fluid}
                />
              ),
      sixth:  (
                <Image
                  alt=""
                  objectPosition={"center"}
                  objectFit={"contain"}
                  fluid={images.img_6.childImageSharp.fluid}
                />
              ),
    },
  };
};
